import {onError} from '@apollo/client/link/error'

const errorLink = onError(({graphQLErrors, networkError}) => {
  if (graphQLErrors) console.log({graphQLErrors})
  if (networkError) console.log({networkError})
})

export default errorLink
